import { Component, EventEmitter, inject, Output } from '@angular/core';
import { PropertyFilter } from '../property-filter/property-filter';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-property-filter-dialog',
  imports: [
    PropertyFilter,
    MatDialogModule
  ],
  templateUrl: './property-filter-dialog.html',
  styleUrl: './property-filter-dialog.scss',
})
export class PropertyFilterDialog {
  private dialogRef = inject<MatDialogRef<PropertyFilterDialog>>(MatDialogRef);

  readonly data = inject<PropertyFilter>(MAT_DIALOG_DATA);
    constructor() {
      console.log('dialog', this.data);
    }

    @Output()
    private _cancel = new EventEmitter<void>();
    public get cancel() {
      return this._cancel;
    }
    public set cancel(value) {
      this._cancel = value;
    }
  }
